module.exports = __webpack_public_path__ + "ecomondo.png?3f8a99edbd89ac1dfdb4dc0d7359b4e2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ecomondo.png
// module id = 178
// module chunks = 0